import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchAndApplyTheme } from "../theme/fetchAndApplyTheme";

const ThemeContext = createContext(0);

export function ThemeProvider({ children }) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    fetchAndApplyTheme().then(() => {
      if (!cancelled) setTick((t) => t + 1);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return <ThemeContext.Provider value={tick}>{children}</ThemeContext.Provider>;
}

/** After theme API loads, this increments so map options (e.g. backgroundColor) re-compute. */
export function useThemeTick() {
  return useContext(ThemeContext);
}
